module.exports = __webpack_public_path__ + "c4f531e11eec569471300e40d8ec8af7.svg";